import { useSnackStack } from "./StackingSnackbarProvider";
import { Stack, Snackbar as MuiSnackbar } from "@mui/material";
import StackingSnackbarToast from "./StackingSnackbarToast";

interface IStackingSnackbarProps {
    bottom?: number;
}

const StackingSnackbar = ({ bottom = 60 } : IStackingSnackbarProps) => {
    const { toastsPack } = useSnackStack();
    const firstToast = toastsPack[0];

    return (
        <MuiSnackbar
          open={!!firstToast}
          autoHideDuration={null}
          transitionDuration={0}
          anchorOrigin={{
            vertical: firstToast?.position?.vertical || "bottom",
            horizontal: firstToast?.position?.horizontal || "center"
          }}
          sx={{
            bottom: bottom,
            padding: '6px 16px',
            width: '100%',
            boxSizing: 'border-box',
            left: 0,
            right: 0,
          }}
        >
          <Stack flexDirection="column" gap={1} width={"100%"}>
            {toastsPack.map((toast) => (
              <StackingSnackbarToast key={toast.key} toast={toast} />
            ))}
          </Stack>
        </MuiSnackbar>
      );
}

export default StackingSnackbar;